import { createSlice } from '@reduxjs/toolkit';
import { fetchContactTypes, createContactType, updateContactType, deleteContactType } from './action';

const contactTypeSlice = createSlice({
  name: 'contactType',
  initialState: {
    data: [],
    status: 'idle',
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchContactTypes.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchContactTypes.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.data = action.payload || [];
      })
      .addCase(fetchContactTypes.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message || 'Failed to load contact types';
      })
      .addCase(createContactType.fulfilled, (state, action) => {
        const item = action.payload;
        if (item) state.data.push(item);
      })
      .addCase(updateContactType.fulfilled, (state, action) => {
        const updated = action.payload;
        if (!updated?._id) return;
        const idx = state.data.findIndex((t) => t._id === updated._id);
        if (idx !== -1) state.data[idx] = updated;
      })
      .addCase(deleteContactType.fulfilled, (state, action) => {
        const id = action.payload;
        state.data = state.data.filter((t) => t._id !== id);
      });
  },
});

export default contactTypeSlice.reducer;

